import React, { Fragment, useState } from 'react';


const ClientInfo = ({ client }) => {

    const [this_client, setThis_client] = useState(client)
    return (
        <Fragment>
            <button type="button" className="btn btn-info" data-toggle="modal" data-target={`#id_admin_client_expand${this_client.client_id}`}>
                Expand
            </button>

            <div className="modal fade" id={`id_admin_client_expand${this_client.client_id}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Client Information</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body">
                            <p>Client ID: {this_client.client_id}</p>
                            <p>NDIS number: {this_client.ndis_number}</p>

                            <p>Name: {this_client.name}</p>
                            <p>Description: {this_client.client_description}</p>

                            <p>Active? {this_client.client_active_display}</p>

                            
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ClientInfo;